import { Row, Card, Table, Tag, notification } from "antd";
import { useTranslation } from "react-i18next";
import classes from "./Etablissements/Etablissements.module.css";
import { getListFormateursByUser } from "../api/geoprod";
import { useEffect, useState } from "react";

const Formateurs = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getListFormateursByUser();
         setData(data?.data?.data || []);
        setLoading(false);
      } catch (error) {
        notification.error({
          message: t("Erreur"),
          description:
            error?.response?.data?.message ||
            "Une interruption est survenue lors de la récupération des données. Veuillez réessayer.",
          duration: 0,
        });
      }
    }

    fetchData();
  }, []);

  const columns = [
    // {
    //   title: t("ID"),
    //   key: "ID",
    //   render: (_, record) => record?.id || t("Non renseigné"),
    // },
    {
      title: t("Nom"),
      key: "Nom",
      render: (_, record) =>
        localStorage.getItem("language") === "ar" && record?.prenom_ar
          ? record?.prenom_ar
          : record?.nom,
    },
    {
      title: t("Prénom"),
      key: "Prénom",
      render: (_, record) =>
        localStorage.getItem("language") === "ar" && record?.nom_ar
          ? record?.nom_ar
          : record?.prenom,
    },
    {
      title: t("Genre"),
      key: "Genre",
      render: (_, record) =>
        localStorage.getItem("language") === "ar"
          ? record?.civilite
          : record?.civilite === "ذكر"
          ? "Masculin"
          : "Féminn",
    },
    {
      title: t("Adresse e-mail"),
      key: "Email",
      render: (_, record) => record?.mail || t("Non renseigné"),
    },
    {
      title: t("Numéro de téléphone"),
      key: "Téléphone",
      render: (_, record) => record?.mobile || t("Non renseigné"),
    },
    {
      title: t("Dénomination EPF"),
      key: "denomination",
      render: (_, record) => record.denomination || t("Non renseigné"),
    },
    {
      title: t("Personne à besoin spécifique"),
      key: "BesoinSpécifique",
      render: (_, record) =>
        record?.special_needs_person ? t("Oui") : t("Non"),
    },
    {
      title: t("Situation"),
      key: "Situation",
      render: (_, record) =>
        localStorage.getItem("language") === "ar"
          ? record?.situation
          : record?.situation === "قار"
          ? "Permanent"
          : "Vacataire",
    },
    {
      title: t("Statut"),
      key: "Statut",
      render: (_, record) => {
        let color = "";
        switch (record?.statut_formateur) {
          case 1:
            color = "green";
            break;
          case 0:
            color = "red";
            break;
          case "Blacklisté":
            color = "volcano";
            break;
          default:
            color = "default";
        }
        return (
          <Tag color={color}>
            {record?.statut_formateur === 1
              ? t("Opérationnel")
              : t("Non opérationnel")}
          </Tag>
        );
      },
    },
    // {
    //   title: t("Actions"),
    //   key: "Actions",
    //   render: (_, record) => (
    //     <Space>
    //       <Tooltip title={t("Voir")}>
    //         <EyeOutlined onClick={() => {}} />
    //       </Tooltip>
    //     </Space>
    //   ),
    // },
  ];

  return (
    <div>
      <Row className={classes.listeRow}>
        <Card
          className={classes.listeCard}
        
          // title={
          //   <div
          //     style={{ textAlign: i18n?.dir() === "ltr" ? "left" : "right" }}
          //   >
          //     {t("Liste des formateurs")}
          //   </div>
          // }
        >
          <Table
            locale={{ emptyText: t("Aucune donnée") }}
            columns={columns}
            dataSource={data}
            className="ant-border-space"
            style={{ overflowX: "auto" }}
            pagination={false}
            loading={loading}
          />
        </Card>
      </Row>
    </div>
  );
};

export default Formateurs;
